import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, DestroyRef, forwardRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { ControlValueAccessorConnector } from '@clean-code/shared/components/ui-form-controls';
import { TranslocoModule } from '@jsverse/transloco';
import { NgSelectModule } from '@ng-select/ng-select';
import { filter, take } from 'rxjs/operators';
import { VisibleToDataService } from './visible-to-data.service';

@Component({
    selector: 'cc-visible-to',
    templateUrl: './visible-to.component.html',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgSelectModule,
        TranslocoModule
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => VisibleToComponent),
            multi: true
        }
    ]
})
export class VisibleToComponent extends ControlValueAccessorConnector implements AfterViewInit {

  private visibleToDataService = inject(VisibleToDataService);
  private destroyRef = inject(DestroyRef);
  private itemsLoaded = false;

  public data$ = this.visibleToDataService
    .getAll$(
      null,
      1000,
      null
    );

  ngAfterViewInit(): void {
    this.data$.pipe(take(1)).subscribe(() => {
      this.itemsLoaded = true;
      this.syncSelectedItems();
    });

    this.formControl?.valueChanges
      ?.pipe(
        filter(
          (value): value is string[] =>
            Array.isArray(value) && value.length > 0,
        ),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.syncSelectedItems();
      });
  }

  private syncSelectedItems(): void {
    if (!this.itemsLoaded) {
      return;
    }

    const value = this.formControl?.value;

    if (!Array.isArray(value) || value.length === 0) {
      return;
    }

    queueMicrotask(() => {
      this.formControl.setValue([...value], { emitEvent: false });
    });
  }
}
